import { Gem, Shield } from "lucide-react";
import { MwpBadge } from "@/components/MwpBadge";

const STYLES = {
  gold: { label: "Exclusive", title: "Exclusive owner", Icon: Gem, cls: "from-amber-300 to-yellow-500 shadow-[0_0_8px_rgba(250,204,21,.6)]" },
  silver: { label: "Wolfpack", title: "Wolfpack (777) owner", Icon: Shield, cls: "from-slate-100 to-slate-400 shadow-[0_0_8px_rgba(203,213,225,.55)]" },
};

export const DropBadge = ({ kind, testid }) => {
  const { label, title, Icon, cls } = STYLES[kind];
  return (
    <span data-testid={testid} title={title} className={`shrink-0 inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-gradient-to-r ${cls} text-[9px] font-sans font-bold text-black uppercase tracking-wider align-middle`}>
      <Icon className="w-2.5 h-2.5" /><span className="hidden sm:inline">{label}</span>
    </span>
  );
};

export const DropBadges = ({ o, testid }) => (
  <>
    {o.exclusive_owner && <DropBadge kind="gold" testid={`${testid}-gold-badge`} />}
    {o.wolfpack_owner && <DropBadge kind="silver" testid={`${testid}-silver-badge`} />}
    {o.mwp_tier && <MwpBadge tier={o.mwp_tier} testid={`${testid}-mwp-badge`} />}
  </>
);
